// extracted by mini-css-extract-plugin
module.exports = {"alertMessage":"styles_alertMessage__1aXFa","message":"styles_message__1XW5p","close":"styles_close__xvIEr","hide":"styles_hide__16x8p"};